<template>
  <div class="footer">
    <div class="wrap" v-html="recordInfo"></div>
  </div>
</template>

<script>
export default {
  name: 'FooterMain',
  data () {
    return {
      recordInfo: ''
    };
  },
  mounted () {
    this.recordInfo = this.$store.getters.recordInfo;
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layout/components/footer.vue